// Utilities for critical (blocking) requests

// Predefined critical request IDs
export const CRITICAL_REQUESTS = {
  FETCH_USER: 'fetchUser',
  FETCH_CURRENT_PLAN: 'fetchCurrentPlan',
  FETCH_AUTH_STATUS: 'fetchAuthStatus',
  FETCH_SUBSCRIPTION_STATUS: 'fetchSubscriptionStatus',
  FETCH_FIRST_TIME_SETUP: 'fetchFirstTimeSetup',
  FETCH_PERMISSIONS: 'fetchPermissions',
  FETCH_COMPANY_DATA: 'fetchCompanyData',
  FETCH_TAX_SETTINGS: 'fetchTaxSettings',
  FETCH_DASHBOARD_DATA: 'fetchDashboardData',
  // New required APIs
  FETCH_USER_DATA: 'fetchUserData',           // GET /api/1/user
  FETCH_APP_ID_DATA: 'fetchAppIdData',        // GET /api/1/users/app_id/
  FETCH_COMPANY_LANGUAGE: 'fetchCompanyLanguage'
}

// Descriptions for critical requests
export const CRITICAL_REQUEST_DESCRIPTIONS = {
  [CRITICAL_REQUESTS.FETCH_USER]: 'Loading user data...',
  [CRITICAL_REQUESTS.FETCH_CURRENT_PLAN]: 'Loading subscription data...',
  [CRITICAL_REQUESTS.FETCH_AUTH_STATUS]: 'Checking authentication...',
  [CRITICAL_REQUESTS.FETCH_SUBSCRIPTION_STATUS]: 'Verifying subscription...',
  [CRITICAL_REQUESTS.FETCH_FIRST_TIME_SETUP]: 'Checking first-time setup...',
  [CRITICAL_REQUESTS.FETCH_PERMISSIONS]: 'Loading permissions...',
  [CRITICAL_REQUESTS.FETCH_COMPANY_DATA]: 'Loading company data...',
  [CRITICAL_REQUESTS.FETCH_TAX_SETTINGS]: 'Loading tax settings...',
  [CRITICAL_REQUESTS.FETCH_DASHBOARD_DATA]: 'Loading home data...',
  // Descriptions for new required APIs
  [CRITICAL_REQUESTS.FETCH_USER_DATA]: 'Loading user profile...',
  [CRITICAL_REQUESTS.FETCH_APP_ID_DATA]: 'Loading application data...',
  [CRITICAL_REQUESTS.FETCH_COMPANY_LANGUAGE]: 'Loading language settings...'
}

// Create a critical request with optional description
export const createCriticalRequest = (requestId, description) => ({
  id: requestId,
  description: description || CRITICAL_REQUEST_DESCRIPTIONS[requestId] || 'Loading...'
})

// Check if a request ID is critical
export const isCriticalRequest = (requestId) => {
  return Object.values(CRITICAL_REQUESTS).includes(requestId)
}

// Get description for a critical request
export const getCriticalRequestDescription = (requestId) => {
  return CRITICAL_REQUEST_DESCRIPTIONS[requestId] || 'Loading...'
}
